module.exports = __webpack_public_path__ + "img/Path 478.3e7d5a2b.svg";